import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Agencies } from 'app/models/agencies';
import { AgenciesService } from 'app/services/agencies/agencies.service';
import { PrimeNGConfig } from 'primeng/api';
import { SearchService } from 'app/services/search/search.service';
import Swal from 'sweetalert2';
import { log } from 'console';
@Component({
  selector: 'app-agences-sousse',
  templateUrl: './agences-sousse.component.html',
  styleUrls: ['./agences-sousse.component.scss']
})
export class AgencesSousseComponent implements OnInit {
  @ViewChild('agencyForm', { static: false })

  agencyForm: NgForm;
  p: Number = 1;
  lengthSociete=10
  totalSociete : any
  closeResult = '';
  search_name1:any;
  

  agenciedData: Agencies;
  dataSource = new MatTableDataSource();
  displayedColumns: string[];
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  isEditMode = false;
  public agencies:any
  public idAgency: any
  public Agency: any
  public search: string  = ''
  pageIndex:number = 0;
  pageSize:number = 50;
  lowValue:number = 0;
  highValue:number = 50; 
  AgenciesSousse:any
  constructor(private agenciesService: AgenciesService,private primengConfig: PrimeNGConfig,
    private searchService: SearchService
    ) { }

  ngOnInit() {
 
    this.getagencesSousse();

  }
  getagencesSousse() {
    this.agenciesService.getListAgenceSousse().subscribe((data: any) => {
      this.AgenciesSousse = data;
      this.agencies = this.AgenciesSousse
      .sort((a: any, b: any) => {
        // Sort based on the existence of projets array
        if (a.biens.length === 0 && b.biens.length > 0) {
          return 1; // Move agencie with empty biens to the end
        } else if (a.biens.length > 0 && b.biens.length === 0) {
          return -1; //   Move agencie with non-empty projets to the beginning
        } else {
          return 0; // No change in order
        }
      });
        
    });
  }
  




  cancelEdit() {
    this.isEditMode = false;
    this.agencyForm.resetForm();
  }

  deleteAgencies(agencie: any,i) {
    Swal.fire({
      title: "Êtes-vous sûr(e) ?",
      text: "Vous ne pourrez pas revenir en arrière !",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Oui, supprimez-le."
    }).then((result) => {
      if (result.isConfirmed) {
        this.agenciesService.deleteItem(agencie.id).subscribe((response: any) => {

          console.log(this.dataSource.data);

          // If you want to show a success message after the deletion, use another Swal.fire here
          Swal.fire({
            title: "Supprimé!",
            text: "Votre agence a été supprimée.",
            icon: "success"
          });
          // Fetch the updated data after deletion
          
          this.AgenciesSousse.splice(i,1)
console.log(this.AgenciesSousse);

        }); 
      }
    });
  }
 public changePage(){
  this.lengthSociete=this.lengthSociete+10;
}

performSearch() {
  this.AgenciesSousse = this.searchService.search(this.AgenciesSousse, this.search);
}
}
